import {
  DonutChart,
  BarChart,
  NMStatsTable,
  Col,
} from "@neumetric/blueprint-lib/components";
import { ExportSection } from "../ExportSection";
import { useSelector } from "react-redux";
import {
  getRemediatorStats,
  getCurrentDateRange,
} from "../../../store/central";

const MODULE_KEY = "Remediator_Priority_vs_Compliance_Status";

export const RemediationPriorityWiseStatsTable = () => {
  const remediatorStats = useSelector(getRemediatorStats);
  const currentDateRange = useSelector(getCurrentDateRange);
  const columns = remediatorStats.priority.columns;
  const tableData = remediatorStats.priority.tableData;
  const dateRangeLabel = currentDateRange ? currentDateRange.label : "";
  return (
    <ExportSection
      moduleKey={MODULE_KEY}
      index={1}
      dateRangeLabel={dateRangeLabel}
      exportType="table"
      exportData={{
        title: "Compliance - Priority-wise",
        columns: columns,
        rows: tableData,
      }}
      style={{
        flex: "1 1 50%",
        maxWidth: "53%",
        padding: "0px 20px 20px 40px",
      }}
    >
      <NMStatsTable
        id="Remediator_Priority_vs_Compliance_Status"
        title="Compliance"
        subTitle="Priority-wise"
        columns={columns}
        dataSource={tableData}
        dateRange={dateRangeLabel}
        showDateInHeader={true}
        getCellTypeRepresentation={(cellInfo) => {
          const dotColumns = ["Complete", "InProgress", "Pending", "Other"];
          if (cellInfo.rowId === -1 && dotColumns.includes(cellInfo.columnId)) {
            return "DOT";
          }
          if (cellInfo.columnId === "priority" && cellInfo.rowId > 0) {
            return "DOT";
          }
          return null;
        }}
      />
    </ExportSection>
  );
};

export const RemediationPriorityWiseBarChart = ({ mode }) => {
  const remediatorStats = useSelector(getRemediatorStats);
  const currentDateRange = useSelector(getCurrentDateRange);
  const chartDatasets = remediatorStats.priority.barData;
  const dateRangeLabel = currentDateRange ? currentDateRange.label : "";
  // dynamic layout styles based on mode
  const containerStyle =
    mode === "fusion"
      ? {
          flex: "1 1 100%",
          minWidth: "100%",
          maxWidth: "100%",
          paddingTop: 0,
          overflow: "visible",
        }
      : {
          flex: "1 1 45%",
          minWidth: 400,
          maxWidth: "50%",
          padding: "0px 40px 20px 0px",
          overflow: "visible",
        };
  return (
    <ExportSection
      moduleKey={MODULE_KEY}
      index={2}
      exportType="chart"
      style={containerStyle}
    >
      <div
        className="chart-export-pad"
        style={{ width: "100%", overflow: "visible" }}
      >
        <div style={{ width: "100%", height: 500 }}>
          <BarChart
            id="Remediator_Priority_vs_Compliance_Status"
            title="Compliance"
            subtitle="Priority-wise"
            label={{ xAxis: "Tasks", yAxis: "Priority" }}
            datasets={chartDatasets}
            dateRange={mode !== "fusion" ? dateRangeLabel : ""}
            showDateInHeader={mode !== "fusion" ? true : false}
            stackType="normal"
            classes={{ root: "h-500-px w-90 mt-12" }}
          />
        </div>
      </div>
    </ExportSection>
  );
};

export const RemediationPriorityWiseDonut = ({ mode }) => {
  const remediatorStats = useSelector(getRemediatorStats);
  const currentDateRange = useSelector(getCurrentDateRange);
  const donutData = remediatorStats.priority.donutData;
  const dateRangeLabel = currentDateRange ? currentDateRange.label : "";
  const donutDatasetToTable = (donutData = []) => {
    const totals = {
      EMERGENCY: 0,
      URGENT: 0,
      CRITICAL: 0,
      HIGH: 0,
      MEDIUM: 0,
      LOW: 0,
      MINIMAL: 0,
      LEAST: 0,
    };

    donutData?.donutDatasets?.forEach((d) => {
      const key = d.key?.toUpperCase();
      if (key in totals) totals[key] += Number(d.value) || 0;
    });
    const DonutColumns = [
      { title: "Emergency", attribute: "EMERGENCY" },
      { title: "Urgent", attribute: "URGENT" },
      { title: "Critical", attribute: "CRITICAL" },
      { title: "High", attribute: "HIGH" },
      { title: "Medium", attribute: "MEDIUM" },
      { title: "Low", attribute: "LOW" },
      { title: "Minimal", attribute: "MINIMAL" },
      { title: "Least", attribute: "LEAST" },
      { title: "Total", attribute: "totalOverall" },
    ];

    const DonutRows = [
      {
        EMERGENCY: totals.EMERGENCY,
        URGENT: totals.URGENT,
        CRITICAL: totals.CRITICAL,
        HIGH: totals.HIGH,
        MEDIUM: totals.MEDIUM,
        LOW: totals.LOW,
        MINIMAL: totals.MINIMAL,
        LEAST: totals.LEAST,
        TOTAL: donutData?.totalOverall,
      },
    ];

    return { DonutColumns, DonutRows };
  };
  const { DonutColumns, DonutRows } = donutDatasetToTable(donutData);

  return (
    <ExportSection
      moduleKey={MODULE_KEY}
      index={mode === "export_everything" ? 3 : 1}
      dateRangeLabel={dateRangeLabel}
      exportType={mode === "export_everything" ? "chart" : "table"}
      exportData={{
        title: "Compliance - Priority-wise",
        columns: DonutColumns,
        rows: DonutRows,
      }}
      style={{
        display: "inline-block",
        width: 350,
        flex: "0 0 auto",
      }}
    >
      <Col style={{ width: 350 }}>
        <div
          style={{
            width: "100%",
            height: 200,
            padding: "20px 10px 0px 0px",
          }}
          className={"remediation-donut"}
        >
          <DonutChart
            chartId="remediator-priority-donut"
            title="Compliance"
            subtitle="Tasks:"
            totalCount={String(donutData.totalOverall)}
            showDateInHeader={mode !== "fusion" ? true : false}
            classes={{ root: "h-200-px" }}
            datasets={donutData.donutDatasets}
            style={{ width: "100%" }}
          />
        </div>
      </Col>
    </ExportSection>
  );
};
